import UserAuthenticator from '../authentication/user-authenticator';
import ModeratorAuthenticator from '../authentication/moderator-authenticator';
import { useNewDesign } from './design-refresh';

const ARTICLE_FORM_TEMPLATE = `
  <ut-article-form-page ng-if="$resolve.useNewDesign" [item]="$resolve.item" [user]="$resolve.user"></ut-article-form-page>
  <ut-article-form ng-if="!$resolve.useNewDesign" [item]="$resolve.item" [user]="$resolve.user"></ut-article-form>
`;

const ArticleRouter = {
  route: (module) => {
    module.config(['$stateProvider', ($stateProvider) => {
      $stateProvider
        .state('articles', {
          url: '/articles',
          controller: ['$state', '$scope', function ($state, $scope) { $scope.$state = $state; }],
          abstract: true,
          template: '<div ui-view="articles-index" ng-show="$state.includes(\'article\')"></div><div ui-view="articles-show" ng-show="$state.includes(\'singlearticle\')" ></div>',
          parent: 'root',
          authenticated: UserAuthenticator,
        })
        .state('article', {
          url: '',
          parent: 'articles',
          sticky: true,
          resolve: {
            title: [() => 'uTest Community Articles'],
            authenticated: UserAuthenticator,
            useNewDesign,
          },
          views: {
            'articles-index': {
              template: `
                <ut-articles-page ng-if="$resolve.useNewDesign" [user]="$resolve.user"></ut-articles-page>
                <ut-articles ng-if="!$resolve.useNewDesign"></ut-articles>
              `,
            },
          },
        })
        .state('singlearticle', {
          parent: 'articles',
          url: '/:articleId?comments?sort',
          reloadOnSearch: false,
          views: {
            'articles-show': {
              template: `
                <ut-article-page ng-if="$resolve.useNewDesign" [article]="$resolve.article" [user]="$resolve.user"></ut-article-page>
                <ut-single-article ng-if="!$resolve.useNewDesign" [article]="$resolve.article"></ut-single-article>
              `,
            },
          },
          resolve: {
            article: ['ArticleService', '$transition$', '$state', '$q', '$timeout', function (ArticleService, $transition$) {
              return ArticleService.find($transition$.params().articleId).then(res => res.data);
            }],
            title: ['article', article => `uTest Community Article - ${article.title}`],
            authenticated: UserAuthenticator,
            useNewDesign,
          },
        })
        .state('pendingarticle', {
          url: '/pending-articles',
          parent: 'root',
          template: '<ut-pending-article></ut-pending-article>',
          resolve: {
            title: [() => 'uTest Community Pending Articles'],
            authenticated: UserAuthenticator,
            moderatorAuthenticated: ModeratorAuthenticator,
          },
        })
        .state('newarticle', {
          url: '/new/article',
          parent: 'root',
          template: ARTICLE_FORM_TEMPLATE,
          resolve: {
            user: UserAuthenticator,
            item() {
              return {
                data: {
                  id: null,
                  title: '',
                  content: '',
                  slug: '',
                  tags: [],
                },
              };
            },
            title: ['item', (item) => {
              let pageTitle;
              if (item.data.id) {
                pageTitle = 'uTest Community - Edit Article';
              } else {
                pageTitle = 'uTest Community - Create New Article';
              }
              return pageTitle;
            }],
            authenticated: UserAuthenticator,
            useNewDesign,
          },
        })
        .state('updatearticle', {
          url: '/update/article/:articleId',
          parent: 'root',
          template: ARTICLE_FORM_TEMPLATE,
          resolve: {
            user: UserAuthenticator,
            item: ['$transition$', 'ArticleService', function ($transition$, ArticleService) {
              return ArticleService.find($transition$.params().articleId);
            }],
            title: ['item', (item) => {
              let pageTitle;
              if (item.data.id) {
                pageTitle = 'uTest Community - Edit Article';
              } else {
                pageTitle = 'uTest Community - Create New Article';
              }
              return pageTitle;
            }],
            authenticated: UserAuthenticator,
            useNewDesign,
          },
        });
    }]);
  },
};

export default ArticleRouter;
